import React from 'react';
import { useDispatch } from 'react-redux';
import { Form, SectionTitle } from '../components';

import { createProduct } from '../redux/actions';
import { productValidationSchema } from '../utils/formSchema';

export default function CreateProduct() {
  const dispatch = useDispatch();

  const initialFieldValues = {
    name: '',
    imageSrc: '',
    description: '',
    price: '',
  };

  const fieldList = [
    { label: 'Product Name', name: 'name', type: 'text' },
    { label: 'Image Link', name: 'imageSrc', type: 'text' },
    { label: 'Description', name: 'description', type: 'text', textarea: true },
    { label: 'Price', name: 'price', type: 'number' },
  ];

  const handleCreateProduct = (values, setIsSubmitted) => {
    dispatch(createProduct(values, setIsSubmitted));
  };

  return (
    <section className="mt-6 px-6">
      <div className="md:grid md:grid-cols-2 md:gap-6">
        <div className="md:col-span-1">
          <SectionTitle label="Create Product" />
          <Form
            fieldList={fieldList}
            initialFieldValues={initialFieldValues}
            buttonText="Create Product"
            handleSubmit={handleCreateProduct}
            validationSchema={productValidationSchema}
          />
        </div>
      </div>
    </section>
  );
}
